module.exports = __webpack_public_path__ + "img/c673aaabd8044dfba1267da32002cb14.2ea5b6ee.png";